import React from 'react';
import './SectionTitle.css';

interface Props {
  eyebrow?: string;
  title: string;
  light?: boolean;
  number?: string;
}

// La última palabra va en <em>: el tema grafito la pone en cursiva Bodoni
// ("TRAYECTORIA Y perfil"); el original la deja igual que el resto.
const splitTitle = (title: string) => {
  const i = title.lastIndexOf(' ');
  return i < 0 ? [title, ''] : [title.slice(0, i + 1), title.slice(i + 1)];
};

const SectionTitle: React.FC<Props> = ({ eyebrow, title, light, number }) => {
  const [head, tail] = splitTitle(title);
  return (
    <div className={`section-title ${light ? 'section-title--light' : ''}`}>
      {number && <span className="section-title__number" aria-hidden="true">{number}</span>}
      {eyebrow && <span className="section-title__eyebrow">{eyebrow}</span>}
      <h2 className="section-title__heading">
        {head}
        {tail && <em className="section-title__em">{tail}</em>}
      </h2>
      <span className="gold-line" />
    </div>
  );
};

export default SectionTitle;
